import { render } from "./MessageLayoutWrapper.vue?vue&type=template&id=c37df084&scoped=true&ts=true"
import script from "./MessageLayoutWrapper.vue?vue&type=script&lang=ts"
export * from "./MessageLayoutWrapper.vue?vue&type=script&lang=ts"

import "./MessageLayoutWrapper.vue?vue&type=style&index=0&id=c37df084&scoped=true&lang=scss"

import exportComponent from "/opt/source/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c37df084"]])

export default __exports__